import type { User } from '../types'
export { canCreateOnBehalf } from './onBehalfAccess'
import { canCreateOnBehalf } from './onBehalfAccess'

/** @deprecated použijte canCreateOnBehalf */
export function canCreateFkspOnBehalf(user: Pick<User, 'role' | 'admin_type'> | null | undefined): boolean {
  return canCreateOnBehalf(user)
}
